const EDIT = 'alert-edit';
const ERROR = 'alert-error';
const REMOVE = 'alert-remove';
const REMOVE_SUCCESS = 'alert-remove-succes';
const CHANGED = 'alerts-changed';
const UPDATE = 'alert-update';

export default {
	EDIT,
	ERROR,
	REMOVE,
	REMOVE_SUCCESS,
	CHANGED,
	UPDATE,
};
